import React, { useState, useRef, useEffect } from 'react';
import './styles.css';
var Select = function (_a) {
    var origin = _a.origin, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.hidden, hidden = _d === void 0 ? false : _d, name = _a.name, options = _a.options, value = _a.value, onChange = _a.onChange, _e = _a.placeholder, placeholder = _e === void 0 ? 'Select' : _e, _f = _a.variant, variant = _f === void 0 ? (origin === 'oncall' ? 'outlined' : 'standard') : _f, dataTestId = _a["data-testid"];
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState({
        top: 0,
        left: 0,
        width: 0,
        maxHeight: 300,
        direction: 'down',
    }), coords = _h[0], setCoords = _h[1];
    var ref = useRef(null);
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function (opt) { return opt.value === value; });
    useEffect(function () {
        var handleClickOutside = function (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return function () { return document.removeEventListener('click', handleClickOutside); };
    }, []);
    var handleOptionClick = function (option) {
        var _a;
        if (disabled)
            return;
        onChange((_a = option.value) !== null && _a !== void 0 ? _a : '');
        setIsOpen(false);
    };
    var calculateCoords = function () {
        if (!ref.current)
            return;
        var rect = ref.current.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var spaceBelow = viewportHeight - rect.bottom;
        var spaceAbove = rect.top;
        var padding = 8; // Padding from the edge of the screen
        var dropdownHeight = 200; // Estimated dropdown height
        var direction = 'down';
        var top = rect.bottom;
        var maxHeight = Math.max(spaceBelow - padding, 100);
        // Check if there's enough space below, otherwise open upwards
        if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
            direction = 'up';
            top = rect.top - dropdownHeight - padding;
            maxHeight = Math.max(spaceAbove - padding, 100);
        }
        setCoords({
            top: top,
            left: rect.left,
            width: rect.width,
            maxHeight: maxHeight,
            direction: direction,
        });
    };
    // Update coordinates when the select is opened on scroll or resize
    useEffect(function () {
        if (!isOpen)
            return;
        calculateCoords();
        window.addEventListener('scroll', calculateCoords, true);
        window.addEventListener('resize', calculateCoords);
        // eslint-disable-next-line consistent-return
        return function () {
            window.removeEventListener('scroll', calculateCoords, true);
            window.removeEventListener('resize', calculateCoords);
        };
    }, [isOpen]);
    var handleOpen = function () {
        if (!disabled && ref.current) {
            calculateCoords();
            setIsOpen(!isOpen);
        }
    };
    if (hidden)
        return null;
    return (React.createElement("div", { id: name, className: "custom-select-wrapper", ref: ref, "data-testid": dataTestId },
        React.createElement("div", { className: "custom-select ".concat(variant, " ").concat(origin, "\n          ").concat(isOpen ? 'open' : '', "\n          ").concat(error ? 'error' : '', "\n          ").concat(disabled ? 'disabled' : ''), onClick: handleOpen, "data-testid": dataTestId ? "".concat(dataTestId, "-trigger") : undefined },
            React.createElement("div", { className: "custom-select-trigger" }, selectedOption ? selectedOption.label : placeholder),
            isOpen && (React.createElement("div", { className: "custom-options ".concat(coords.direction === 'up' ? 'custom-options--up' : ''), style: {
                    position: 'fixed',
                    top: coords.top,
                    left: coords.left,
                    width: coords.width,
                    maxHeight: coords.maxHeight,
                    zIndex: 9999,
                    overflowY: 'auto',
                }, "data-testid": dataTestId ? "".concat(dataTestId, "-options") : undefined }, options === null || options === void 0 ? void 0 : options.map(function (option) { return (React.createElement("div", { key: option.value, className: "custom-option ".concat(value === option.value ? 'selected' : ''), onClick: function () { return handleOptionClick(option); }, "data-testid": dataTestId ? "".concat(dataTestId, "-option-").concat(option.value) : undefined }, option.label)); }))))));
};
export default Select;
//# sourceMappingURL=Select.js.map